import { connect } from 'react-redux';
import {
    formFinderConfigLoad,
    formFinderConfigUnload,
    finderUpdateName,
    finderUpdateSections,
    finderUpdatedSections,
    finderChangeStep,
    stepDialogStatePrepare,
} from '../actions';
import FormFinderBuilder from './FormFinderBuilder';
import isEqual from 'lodash/isEqual';

const compareUpdatedFormFinderNextSteps = (savedFinder, formFinderBuilder) => {
    return !isEqual(savedFinder.steps, Object.assign({}, formFinderBuilder.steps));
};

const mapStateToProps = ({ formFinderBuilder }) => {
    const savedFinder = formFinderBuilder.lastSavedFinder;
    const unsavedFormFinder =
        !isEqual(formFinderBuilder.formFinder, savedFinder) ||
        (savedFinder.steps ? compareUpdatedFormFinderNextSteps(savedFinder, formFinderBuilder) : false);
    return {
        formFinder: formFinderBuilder.formFinder,
        currentStep: formFinderBuilder.activeStep,
        steps: formFinderBuilder.steps,
        formOptions: formFinderBuilder.forms,
        unsavedChanges: unsavedFormFinder,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onLoad: (id) => {
        dispatch(formFinderConfigLoad(id));
    },
    onUnload: () => {
        dispatch(formFinderConfigUnload());
    },
    onNameChange: (name) => {
        dispatch(finderUpdateName(name));
    },
    onSectionsChange: (index, type, step) => {
        dispatch(finderUpdateSections({ index, type, step }));
    },
    onStepChange: (step) => {
        dispatch(finderChangeStep(step));
    },
    onStepsReorder: (steps) => {
        dispatch(finderUpdatedSections(steps));
    },
    onEditStep: (step) => {
        dispatch(stepDialogStatePrepare(step));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(FormFinderBuilder);
